// src/utils/authUtils.ts

import { useRecoilState } from 'recoil'
import { authState } from '../atoms/auth'
import { getUser } from '../services/apiService'

export const useAuthState = () => {
  const [auth, setAuth] = useRecoilState(authState)

  const reloadUser = async () => {
    try {
      const { data: res } = await getUser()
      if (res.statusCode === 200) {
        setAuth(res.data)
      }
    } catch (error) {
      // 에러 스킵
    }
  }

  const reloadUserErr = async () => {
    try {
      const { data: res } = await getUser()
      if (res.statusCode === 200) {
        setAuth(res.data)
      }
    } catch (error) {
      throw error
    }
  }

  const initUser = async () => {
    setAuth({
      id: null,
      account: '',
      username: '',
      nickname: null,
      email: null,
      phone: '',
      grade: null,
      apiKey: null,
      apiSecret: null,
      apiPassword: null,
      apiKeySpot: null,
      apiSecretSpot: null,
      bscDepositWalletAddress: '',
      bscWithdrawWalletAddress: null,
      trcDepositWalletAddress: '',
      trcWithdrawWalletAddress: null,
      usdtBalance: '0',
      pointBalance: '0',
      profileImageUrl: null,
      isAdmin: 0,
      serviceAt: null,
      referralAt: null, // ✅ 추가
      subscriptionAt: null, // ✅ 추가
      parentId: null,
      createdAt: '',
      updatedAt: null,
      deletedAt: null,
      trading: [],
      spot: []
    })
  }

  // ✅ 반환 추가
  return {
    reloadUser,
    reloadUserErr,
    initUser
  }
}
